import { render, staticRenderFns } from "./ListCover.vue?vue&type=template&id=9c3fe588"
import script from "./ListCover.vue?vue&type=script&lang=js"
export * from "./ListCover.vue?vue&type=script&lang=js"
import style0 from "./ListCover.vue?vue&type=style&index=0&id=9c3fe588&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports